import { CHAINS_INFO_MAP } from '@dynamic-labs-sdk/client/core';

export const solanaApiChainName = CHAINS_INFO_MAP.SOL.apiChainName;

/**
 * List of methods that may be requested from Solana wallet applications.
 *
 * Source: https://github.com/reown-com/appkit/blob/fe11a72507af09efcfe89228189aeda04dfe17a9/packages/appkit-utils/src/WCNamespaceUtil.ts#L9
 */
export const solanaMethods = [
  'solana_signMessage',
  'solana_signTransaction',
  'solana_requestAccounts',
  'solana_getAccounts',
  'solana_signAllTransactions',
  'solana_signAndSendTransaction',
] as const;

/**
 * List of blockchain hashes for all solana networks.
 *
 * You will find the main hashes here: https://namespaces.chainagnostic.org/solana/caip10
 * However, this list also includes the legacy hashes for mainnet and devnet for maximum compatibility.
 * You will find the legacy hashes here: https://chainagnostic.org/CAIPs/caip-30
 *
 * Note that this list was not originally fetched from those sources, however. Instead, we manually inspected
 * which networks were passed as argument to the signClient.connect method in the official reown Solana demo
 * which you can find here: https://lab.reown.com/appkit/?name=multichain-all
 */
export const solanaNetworks = [
  // mainnet
  'solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp',
  // legacy mainnet
  'solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ',
  // testnet
  'solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z',
  // devnet
  'solana:EtWTRABZaYq6iMfeYKouRu166VU2xqa1',
  // legacy devnet
  'solana:8E9rvCKLFQia2Y35HXjjpWzj8weVo44K',
] as const;
